import { produce } from 'immer'
import { create } from 'zustand'

type CommitItem = {
  repoId: number
  sha: string
}

type GeneratorState = {
  loading: boolean
  list: CommitItem[]
  toggleCommit(repoId: number, sha: string): void
  reset(): void
}

export const useGeneratorState = create<GeneratorState>(set => ({
  loading: false,
  list: [],

  toggleCommit: (repoId, sha) => {
    set(produce((s: GeneratorState) => {
      const index = s.list.findIndex(commit => commit.repoId === repoId && commit.sha === sha)
      if (index > -1) {
        s.list = s.list.filter((_, idx) => idx !== index)
      }
      else {
        s.list.push({ repoId, sha })
      }
    }))
  },

  reset() {
    set({ list: [] })
  },
}))
